<template>
    <paginate
        :page-count="total"
        :click-handler="onChange"
        prev-text="<svg aria-hidden=&quot;true&quot; focusable=&quot;false&quot; data-prefix=&quot;fas&quot; data-icon=&quot;caret-left&quot; role=&quot;img&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot; viewBox=&quot;0 0 192 512&quot; class=&quot;svg-inline--fa fa-caret-left fa-w-6&quot;><path fill=&quot;currentColor&quot; d=&quot;M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z&quot;></path></svg>"
        next-text="<svg aria-hidden=&quot;true&quot; focusable=&quot;false&quot; data-prefix=&quot;fas&quot; data-icon=&quot;caret-right&quot; role=&quot;img&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot; viewBox=&quot;0 0 192 512&quot; class=&quot;svg-inline--fa fa-caret-right fa-w-6&quot;><path fill=&quot;currentColor&quot; d=&quot;M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z&quot;></path></svg>"
        :container-class="'pagination'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
    >
  </paginate>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true,
        }
    },
    methods: {
        onChange(page) {
            this.$emit('change', page);
        }
    }
}
</script>

<style>

</style>